import {
  CreateUserWalletRequestDto,
  CreateUserWalletResponseDto,
  ReadUserWalletsRequestDto,
  ReadUserWalletsResponseDto,
  UpdateUserWalletRequestDto,
  UpdateUserWalletResponseDto,
  DeleteUserWalletRequestDto,
  DeleteUserWalletResponseDto,
  ReadUserSfWalletsRequestDto,
  ReadUserSfWalletsResponseDto,
  IUserWallet,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import isNil from 'lodash/isNil'

export const createUserWallet = async (
  { token, ...params }: CreateUserWalletRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateUserWalletResponseDto> => {
  const response = await axios.post<CreateUserWalletResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/wallets`,
    Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserWallets = async (
  { token, ...params }: ReadUserWalletsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserWalletsResponseDto> => {
  const response = await axios.get<ReadUserWalletsResponseDto>(`${process.env.REACT_APP_REST_API_URL}/user/wallets`, {
    ...options,
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.data
}

export const updateUserWallet = async (
  { token, id, ...params }: UpdateUserWalletRequestDto & { id: number; token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateUserWalletResponseDto> => {
  const response = await axios.patch<UpdateUserWalletResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/wallets/${id}`,
    params,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const deleteUserWallet = async (
  { token, id }: DeleteUserWalletRequestDto & { id: number; token: string },
  options: AxiosRequestConfig = {},
): Promise<DeleteUserWalletResponseDto> => {
  const response = await axios.delete<DeleteUserWalletResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/wallets/${id}`,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserSfWallets = async (
  { token, ...params }: Omit<ReadUserSfWalletsRequestDto, 'idSf'> & { token: string },
  options: AxiosRequestConfig = {},
): Promise<{ data: ReadUserSfWalletsResponseDto }> => {
  const response = await axios.get<{ data: ReadUserSfWalletsResponseDto }>(
    `${process.env.REACT_APP_REST_API_URL}/user/sf-wallets`,
    {
      ...options,
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value))),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserWalletsList = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<IUserWallet[]> => {
  const response = await axios.get<IUserWallet[]>(`${process.env.REACT_APP_REST_API_URL}/user/wallets/list`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return response.data.data
}
